"use client"

import { ComponentConfig, DropZone } from "@measured/puck"
import { CommonStylesProps } from "../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../lib/helper"
import useIsMobile from "../../lib/use-is-mobile"

export interface BoxProps extends CommonStylesProps {}

export const RenderConfig: ComponentConfig<BoxProps> = {
  render: ({ className, styles, responsiveType, editMode }) => {
    // Generate a unique ID for the component for dynamic CSS scoping
    const id = `box-${Math.random().toString(36).substr(2, 9)}`
    const isMobile = useIsMobile()

    // Generate responsive CSS
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)
    const desktopStyle = styles?.desktop
    const mobileStyle = styles?.mobile
    return (
      <>
        {editMode ?? responsiveCSS}

        <div className={id + " " + className}>
          <DropZone
            zone="item"
            style={
              {
                ...(editMode && { margin: "auto", width: "100%" }),
                ...(editMode && (isMobile ? mobileStyle : desktopStyle)),
              } as React.CSSProperties
            }
          />
        </div>
      </>
    )
  },
}
